/*
 * This is the initial API interface
 * we set the base URL for the API
 */

import axios from "axios";
import store from "@/store";
import {Keys} from '/src/config.js'
export const apiClient = axios.create({
  baseURL: Keys.VUE_APP_API_URL + "/api",
  //withCredentials: true, // required to handle the CSRF token
});

/*
 * Add a request interceptor to include auth token
 */
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('freshToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/*
 * Add a response interceptor
 */
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (
      error.response &&
      [401, 419].includes(error.response.status) &&
      store.getters["auth/authUser"] &&
      !store.getters["auth/guest"]
    ) {
      store.dispatch("auth/logout");
    }
    return Promise.reject(error);
  }
);
